/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import IMunicipio from 'Infotrack@Modelos/administracion/municipio/entidades/municipio';
import IClientes from 'Infotrack@Modelos/smartStock/clientes/entidades/clientes';
import ITiposClientes from 'Infotrack@Modelos/smartStock/tiposClientes/entidades/tiposClientes';
import { AnyAction } from 'redux';

export interface IEstadoClientes {
    estadoFormulario: boolean;
    entidadClientes: IClientes | null;
    entidadesClientes: {
        municipios: IMunicipio[];
        tiposClientes: ITiposClientes[];
    };
    recargarTabla: boolean;
    tipoFormulario: TipoFormulario;
}

export const estadoInicial: IEstadoClientes = {
    estadoFormulario: false,
    entidadClientes: null,
    entidadesClientes: {
        municipios: [],
        tiposClientes: [],
    },
    recargarTabla: false,
    tipoFormulario: TipoFormulario.Creacion,
};

export enum acciones {
    CAMBIAR_ESTADO_FORMULARIO = 'CAMBIAR_ESTADO_FORMULARIO',
    RECARGAR_TABLA = 'RECARGAR_TABLA',
    ESTABLECER_ENTIDADES_CLIENTE = 'ESTABLECER_ENTIDADES_CLIENTE',
}

export const reductor = (estado: IEstadoClientes = estadoInicial, { type, payload }: AnyAction) => {
    switch (type) {
        case 'CAMBIAR_ESTADO_FORMULARIO': {
            return {
                ...estado,
                entidadClientes: payload ? payload.entidadClientes : null,
                estadoFormulario: !estado.estadoFormulario,
                tipoFormulario: payload ? payload.tipoFormulario : estado.tipoFormulario,
            };
        }
        case 'RECARGAR_TABLA':
            return {
                ...estado,
                recargarTabla: !estado.recargarTabla,
            };

        case 'ESTABLECER_ENTIDADES_CLIENTE':
            return {
                ...estado,
                entidadesClientes: payload,
            };

        default:
            return estado;
    }
};
